import { styled } from '@linaria/react';

export const BannerContainer = styled.div`
	position: relative;
	width: 100%;
	min-width: 0;
	max-width: 1170px;
	height: auto;
	margin: 0 auto;
`;
